import { Model } from "@tailflow/laravel-orion/lib/model";

export class Country extends Model<{
  name: string;
}> {
  public $resource(): string {
    return "countries";
  }
}
